import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fs-3" }

import { ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DepositReference',
  setup(__props, { expose: __expose }) {

const isLoading = ref(true);
const modalForm = ref<InstanceType<typeof SimpleForm>>();
const referNumber = ref("");

__expose({
  async show(_referNumber: any) {
    modalForm.value?.show();
    referNumber.value = _referNumber.TransactionRefNo;
  },
  hide() {
    modalForm.value?.hide();
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SimpleForm, {
      ref_key: "modalForm",
      ref: modalForm,
      title: _ctx.$t('title.poliReferanceNumber'),
      "is-loading": isLoading.value,
      "disable-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.$t("title.referanceNumber")) + ": ", 1),
          _createElementVNode("strong", null, _toDisplayString(referNumber.value), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "is-loading"])
  ]))
}
}

})